// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zAgB","col":"styles_col__u_tun","actions":"styles_actions__1HXbm","conflict":"styles_conflict__2i1P9"};